import React, { createContext, useContext, useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getRoomsWithReception } from "../../../Map/store/MapDisplayThunks";
import { getSteps } from "./steps";

const GuidedTourContext = createContext();

export const useGuidedTour = () => useContext(GuidedTourContext);

export const GuidedTourProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const targetsRef = useRef({});
  const dispatch = useDispatch();

  // Rooms avec is_reception
  const receptionRoomsData = useSelector((state) => state.MapDisplay.receptionRoomsData);

  const steps = React.useMemo(() => {
    return getSteps(receptionRoomsData);
  }, [receptionRoomsData]);

  const currentStep = steps[stepIndex];
  const [rooms, setRooms] = useState([]);

  const totalSteps = steps.filter(
    (step) => !step.excludeFromCount
  ).length;

  let visibleStepIndex = steps.length > 0 ?
    steps
      .slice(0, stepIndex + 1)
      .filter((step) => !step.excludeFromCount)
      .length : 0;

  if (visibleStepIndex === 0) {
    visibleStepIndex = 1;
  }

  const showProgress = !currentStep?.excludeFromCount;

  const start = () => {
    setStepIndex(0);
    setIsOpen(true);
  };

  const next = () => {
    if (stepIndex < steps.length - 1) {
      setStepIndex(stepIndex + 1);
    } else {
      setIsOpen(false);
    }
  };

  const prev = () => {
    if (stepIndex > 0) {
      setStepIndex(stepIndex - 1);
    }
  };

  const close = () => setIsOpen(false);

  return (
    <GuidedTourContext.Provider
      value={{
        isOpen,
        start,
        next,
        prev,
        close,

        currentStep,
        stepIndex,

        totalSteps,
        visibleStepIndex,
        showProgress,
        rooms,
        setRooms,

        registerTarget: (name, el) => {
          targetsRef.current[name] = el;
        },

        getTarget: (name) => targetsRef.current[name],
      }}
    >
      {children}
    </GuidedTourContext.Provider>
  );
};